// let gapiInitialized = false;

// const CLIENT_ID = process.env.VUE_APP_GOOGLE_CLIENT_ID?.trim();
// // const API_KEY = process.env.VUE_APP_GOOGLE_API_KEY?.trim();

// const DISCOVERY_DOCS = [
//   "https://www.googleapis.com/discovery/v1/apis/people/v1/rest"
// ];
// const SCOPES = "https://www.googleapis.com/auth/contacts.readonly";

// /**
//  * Dynamically loads GAPI if not already available.
//  */
// function loadGapiScript() {
//   return new Promise((resolve, reject) => {
//     if (window.gapi) return resolve();

//     const script = document.createElement("script");
//     script.src = "https://apis.google.com/js/api.js";
//     script.async = true;
//     script.defer = true;
//     script.onload = resolve;
//     script.onerror = () => reject(new Error("Failed to load GAPI script"));
//     document.head.appendChild(script);
//   });
// }

// /**
//  * Initialize GAPI client with auth2
//  */
// export async function initGapiClient() {
//   if (gapiInitialized) return;

//   await loadGapiScript();

//   return new Promise((resolve, reject) => {
//     window.gapi.load("client:auth2", async () => {
//       try {
//         await window.gapi.client.init({
//           // apiKey: API_KEY,
//           clientId: CLIENT_ID,
//           discoveryDocs: DISCOVERY_DOCS,
//           scope: SCOPES,
//         });
//         gapiInitialized = true;
//         resolve();
//       } catch (error) {
//         console.error("GAPI Init Error:", error);
//         reject(error);
//       }
//     });
//   });
// }

// /**
//  * Sign in the user interactively
//  */
// export async function signIn() {
//   if (!window.gapi?.auth2) {
//     throw new Error("GAPI auth2 not initialized. Call initGapiClient() first.");
//   }
//   return window.gapi.auth2.getAuthInstance().signIn();
// }

// /**
//  * Fetch Google contacts
//  */
// export async function fetchGoogleContacts() {
//   if (!gapiInitialized) {
//     throw new Error("GAPI not initialized. Call initGapiClient() first.");
//   }

//   const response = await window.gapi.client.people.people.connections.list({
//     resourceName: "people/me",
//     personFields:
//       "names,emailAddresses,phoneNumbers,photos"
//   });

//   return response.result.connections || [];
// }


const clientId = '549216994296-rvv4savare97lj6eaeiijsnjh2su63uj.apps.googleusercontent.com';
const scope = [
  'https://www.googleapis.com/auth/contacts.readonly',
  'https://www.googleapis.com/auth/userinfo.profile',
  'https://www.googleapis.com/auth/userinfo.email'
].join(' ');

const REDIRECT_URI = `${process.env.VUE_APP_URL}/contacts`; 


export function openGoogleAuthPopup() {
  const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?` +
    `client_id=${clientId}` +
    `&redirect_uri=${REDIRECT_URI}` +
    `&response_type=token` +
    `&scope=${encodeURIComponent(scope)}` +
    `&include_granted_scopes=true` +
    `&prompt=consent`;

  const width = 500;
  const height = 600;
  const left = (screen.width / 2) - (width / 2);
  const top = (screen.height / 2) - (height / 2);

  const popup = window.open(
    authUrl,
    'GoogleAuthPopup',
    `width=${width},height=${height},top=${top},left=${left}`
  );

  return new Promise((resolve, reject) => {
    const interval = setInterval(() => {
      try {
        if (!popup || popup.closed) {
          clearInterval(interval);
          reject(new Error('Popup closed by user'));
        }

        const popupUrl = popup.location.href;

        if (popupUrl.includes('#access_token=')) {
          const params = new URLSearchParams(popup.location.hash.substring(1));
          const token = params.get('access_token');

          clearInterval(interval);
          popup.close();
          resolve(token);
        }
      } catch (err) {
        // ignore CORS error until redirect URI matches
      }
    }, 500);
  });
}

export async function fetchContactsFromGoogle(token) {
  const res = await fetch(
    'https://people.googleapis.com/v1/people/me/connections?personFields=names,emailAddresses,phoneNumbers,photos',
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
  const data = await res.json();
  return data.connections || [];
}
